import { Injectable } from '@angular/core';
import { environment } from '@environment';

@Injectable({ providedIn: 'root' })
export class Configuration {
  // Map to the fund object properties in the target environment
  environmentName = environment.fund?.environmentName;
  tenantId = environment.tenantId;
  server = environment.fund?.server || environment.apiUrl;
  multiCurrency = environment.fund?.multiCurrency;
  homeLink = environment.fund?.homeLink;
  mailTo = environment.fund?.mailTo;
  stripeKey = environment.fund?.stripeKey;
  wiringInstructions = environment.fund?.wiringInstructions;
  eftInstructions = environment.fund?.eftInstructions;
  primaryColor = environment.fund?.primaryColor;
  secondaryColor = environment.fund?.secondaryColor;
  ternaryColor = environment.fund?.ternaryColor;
  logo = environment.fund?.logo;
  publicLogo = environment.fund?.publicLogo;
  lightDonateNowButtonLink = environment.fund?.lightDonateNowButtonLink;
  darkDonateNowButtonLink = environment.fund?.darkDonateNowButtonLink;
  lightDonateNowButtonSrc = environment.fund?.lightDonateNowButtonSrc;
  darkDonateNowButtonSrc = environment.fund?.darkDonateNowButtonSrc;
  favicon = environment.fund?.favicon;
  contact = environment.fund?.contact;
  blog = environment.fund?.blog;
  name = environment.fund?.name;

  constructor() {}
}
